import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  pillBase: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#FFFFFF',
    border: 'solid 1px',
    borderRadius: '15px',
    padding: '1px 8px',
    height: '20px',
    minHeight: '20px',
    minWidth: '26px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '12px',
    cursor: 'default',
  },
  points: {
    marginRight: '0px',
  },
  pillLabel: {
    fontSize: '10px',
    fontWeight: 400,
    marginRight: '3px',
    opacity: 0.8,
  },
}));
